import React from 'react';
import { colorGray } from 'styles/layout/colors';
import PropTypes from 'prop-types';

const IconPlus = ({ color = colorGray, ...props }) => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 13.25H21.385V11.75H3V13.25Z"
      fill={color}
    />
  </svg>
);

IconPlus.propTypes = {
  color: PropTypes.string,
};

export default IconPlus;
